import { useDetailedQuote } from '@benzinga/quotes-manager-hooks';
import { useQuoteSubscription } from '@benzinga/quotes-v3-manager-hooks';
import { StockSymbol } from '@benzinga/session';
import { isEmpty, numberShorthand } from '@benzinga/utils';
import styled from 'styled-components';

interface QuoteDataProps {
  symbol: StockSymbol;
}

export const QuoteData: React.FC<QuoteDataProps> = props => {
  const shareFloat = useDetailedQuote(props.symbol)?.ok?.sharesFloat;
  const quote = useQuoteSubscription(props.symbol, new Set(['symbol', 'shareFloat', 'dayVolume']));
  return (
    <StyledQuoteData>
      <div>Volume : {!quote?.volume || isEmpty([quote?.volume]) ? '--' : numberShorthand(quote?.volume)}</div>
      <div>Float : {!shareFloat || isEmpty([shareFloat]) ? '--' : numberShorthand(shareFloat)}</div>
    </StyledQuoteData>
  );
};

const StyledQuoteData = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 5px 10px;
  font-size: 1em;
  color: ${props => props.theme.colors.foregroundInactive};
  font-weight: 300;
  white-space: nowrap;
  line-height: 1.5;
  :first-child {
    font-weight: 500;
  }
  :last-child {
    font-weight: 500;
  }
`;
